module.exports = __webpack_public_path__ + "img/menu-no-operation-hours.1d9528ce.svg";